var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _vm.hasRemoveEvent
        ? _c("remove-warning", {
            attrs: {
              removeEvent: _vm.getRemoveEvent,
              label: "Warning.eventRemove.label",
              content: "Warning.eventRemove.content"
            },
            on: { remove: _vm.removeEvent, cancel: _vm.closeRemoveWarning }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("h4", { staticClass: "text-center mb-4" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("Campaign.preview.message")) + "\n  ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row m-0 m-0" }, [
        _c(
          "p",
          { staticClass: "col pl-0 pr-0 m-0" },
          [
            _c("span", { staticClass: "float-left centering" }, [
              _c("h4", { staticClass: "campaign-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.getCampaignLabel) +
                    ":\n          " +
                    _vm._s(_vm.getCampaignSchedule) +
                    "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("button-nav", {
              staticClass: "float-right d-none d-sm-none d-md-flex",
              attrs: { buttons: _vm.avalableActions },
              on: {
                edit: _vm.editCampaign,
                pauseCampaign: _vm.pauseCampaign,
                resumeCampaign: _vm.resumeCampaign
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "table",
        { staticClass: "m-0 mt-4 w-100" },
        [
          _c("thead", [
            _c("tr", [
              _c("td", [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("Campaign.preview.photo")) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("Campaign.preview.title")) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("Campaign.preview.price")) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("Campaign.preview.discountedPrice")) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("Campaign.preview.channel")) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("Campaign.preview.time")) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c("td")
            ])
          ]),
          _vm._v(" "),
          _vm._l(_vm.getCampaignEvents, function(e) {
            return _c(
              "tbody",
              { key: e[0] },
              [
                _c("tr", [
                  _c("td", { staticClass: "pt-3" }, [
                    _c("h5", { staticClass: "m-0 day-label" }, [
                      _vm._v("\n            " + _vm._s(e[0]) + "\n          ")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm._l(e[1], function(event) {
                  return _c("tr", { key: event.id }, [
                    _c("td", [
                      _c("img", {
                        staticClass: "mr-3",
                        attrs: {
                          width: "50px",
                          height: "50px",
                          src: event.image
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n          " + _vm._s(event.label) + "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      event.price.old
                        ? _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(event.price.old) +
                                " eur\n          "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      event.price.new
                        ? _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(event.price.new) +
                                " eur\n          "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("q-image", {
                          staticClass: "mr-2",
                          attrs: {
                            pack: event.icon.pack,
                            name: event.icon.name,
                            width: "30px",
                            height: "30px"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "\n            " +
                              _vm._s(event.channel) +
                              "\n          "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.formatTime(event.time)) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              modifiers: { hover: true }
                            }
                          ],
                          staticClass: "action-buttons",
                          attrs: { title: _vm.$t("Button.delete") },
                          on: {
                            click: function($event) {
                              return _vm.deleteMpe(event.id)
                            }
                          }
                        },
                        [
                          _c("icon", {
                            staticClass: "delete",
                            attrs: { name: "trash" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              modifiers: { hover: true }
                            }
                          ],
                          staticClass: "action-buttons",
                          attrs: { title: _vm.$t("Button.edit") },
                          on: {
                            click: function($event) {
                              return _vm.editMpe(event.id)
                            }
                          }
                        },
                        [
                          _c("icon", {
                            staticClass: "edit",
                            attrs: { name: "edit" }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                })
              ],
              2
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row m-0 m-0 bottom-buttons" }, [
        _c(
          "p",
          { staticClass: "col pl-0 pr-0 m-0" },
          [
            _c("button-nav", {
              staticClass: "float-right d-none d-sm-none d-md-flex",
              attrs: { buttons: _vm.avalableActions },
              on: {
                edit: _vm.editCampaign,
                pauseCampaign: _vm.pauseCampaign,
                resumeCampaign: _vm.resumeCampaign
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38ac61e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38ac61e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/service/campaignManager/campaignPreview/ActiveCampaignPreview.vue
// module id = null
// module chunks = 